import React, { useEffect, useState } from "react";
import { toPersianNum, toEnglishNum } from "../../assets/utils";

const Time = () => {
  const getTime = () => {
    const date = new Date();

    const min = date.getMinutes();
    const hour = date.getHours();
    // console.log(min);
    return { min, hour };
  };

  const getDate = () => {
    const date = new Date();
    const datePer = new Date().toLocaleDateString("fa-IR");

    const seperated = datePer.split("/");

    const dayOfMonth = seperated[2];

    let dayOfWeek = date.getDay();
    switch (dayOfWeek) {
      case 0:
        dayOfWeek = "یک‌شنبه";
        break;

      case 1:
        dayOfWeek = "دوشنبه";
        break;

      case 2:
        dayOfWeek = "سه‌شنبه";
        break;

      case 3:
        dayOfWeek = "چهارشنبه";
        break;

      case 4:
        dayOfWeek = "پنج‌شنبه";
        break;

      case 5:
        dayOfWeek = "جمعه";
        break;

      case 6:
        dayOfWeek = "شنبه";
        break;

      default:
        break;
    }
    // console.log(dayOfWeek);

    let month = toEnglishNum(seperated[1]);
    switch (Number(month)) {
      case 1:
        month = "فروردین";
        break;
      case 2:
        month = "اردیبهشت";
        break;
      case 3:
        month = "خرداد";
        break;
      case 4:
        month = "تیر";
        break;
      case 5:
        month = "مرداد";
        break;
      case 6:
        month = "شهریور";
        break;
      case 7:
        month = "مهر";
        break;
      case 8:
        month = "آبان";
        break;
      case 9:
        month = "آ‌‌ذر";
        break;
      case 10:
        month = "دی";
        break;
      case 11:
        month = "بهمن";
        break;
      case 12:
        month = "اسفند";
        break;

      default:
        // month = "sd";
        break;
    }

    // console.log(month);
    // console.log(dayOfWeek);
    // console.log(dayOfMonth);

    return { dayOfMonth, dayOfWeek, month };
  };

  const [time, setTime] = useState("");
  const [date, setDate] = useState("");

  useEffect(() => {
    const newTime = getTime();
    // console.log(time.hour);
    setTime(newTime);

    const newDate = getDate();
    setDate(newDate);
    // const newDate = new Date().toLocaleDateString("fa-IR");
    // setDate(newDate);

    const interval = setInterval(() => {
      const newTime = getTime();
      // console.log(time.hour);
      setTime(newTime);
    }, 60000);
    // const date = new Date();
    // console.log(date.getMinutes());
    return () => {
      // alert("hi");
      clearInterval(interval);
    };
  }, []);

  return (
    <div
      className="d-flex align-items-center justify-content-end text-white"
      style={{ height: "84px" }}
    >
      <div
        className="bg--blue-dark h-100 d-flex flex-column font-weight-bold justify-content-center align-items-center p-1 ml-3"
        style={{
          width: "60px",
          fontSize: "3.167em",
          lineHeight: "1",
          borderRadius: "10px",
        }}
      >
        <div>{time.hour ? toPersianNum(time.hour) : null}</div>
        <div style={{ WebkitTextStroke: "1px white", color: "transparent" }}>
          {time.min ? toPersianNum(time.min) : null}
        </div>
      </div>
      <div
        className="bg--blue-dark h-100 d-flex flex-column justify-content-center align-items-center p-1"
        style={{ width: "60px", borderRadius: "10px" }}
      >
        <div className="mb-1">{date ? date.dayOfWeek : null}</div>
        <div style={{ fontSize: "3.167em", lineHeight: 1 }}>
          {date ? date.dayOfMonth : null}
        </div>
        <div>{date ? date.month : null}</div>
      </div>
    </div>
  );
};

export default Time;
